import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo, useRef, useState } from "react";
import { isEmpty, values, size, merge, cloneDeep, join, get, some, flatMap, find } from "lodash";
// @ts-ignore
import dcmjs from "dcmjs";
import dicomParser from "dicom-parser";
import classNames from "classnames";
import FileDropzone from "./FileDropzone";
import Footer from "./Footer";
import GuidelineModal from "./GuidelineModal";
import { convertBufferToFile, formatJsDateToDicomDateString, generatePatientId, getGender, isNonDicomFile, parseAgeInYearsFromDicomAttribute, parseDicomPatientBirthDateToDate } from "../../utils";
import SelectWorkspace from "../SelectWorkspace";
import constants from "../../utils/constants";
import { t } from "i18next";
import Loader from "../Loader";
import CropImage from "./CropImage";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import RegistrationForm from "./RegistrationForm";
import ScanUpload from "./ScanUpload";
import useWorkspacePermittedData from "../WorkspaceManagement/services/useWorkspacePermittedData";
import getEnv from "../../utils/getEnv";
import ParentModal from "./ParentModal";
import { readFile, toFilesObject, updateFileState } from "./utils";
import { useAuth } from "@qure/qure-auth";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
var INITIAL_UPLOAD_STATE = constants.UPLOAD_STATE.NOT_STARTED;
var disableScanUpload = getEnv("NEXT_PUBLIC_DISABLE_SCAN_UPLOAD") === "true";
var isLC = process.env.NEXT_PUBLIC_IS_LC === "true";
var UploadModal = function UploadModal(props) {
  var onClose = props.onClose,
    onConfirmUpload = props.onConfirmUpload,
    setSelectedSource = props.setSelectedSource,
    selectedSource = props.selectedSource,
    currentPatient = props.currentPatient,
    hasCurrentPatient = props.hasCurrentPatient,
    isUploadInProgress = props.isUploadInProgress,
    patient = props.patient,
    setPatient = props.setPatient;
  var _useState = useState({}),
    selectedFiles = _useState[0],
    setSelectedFiles = _useState[1];
  var _useState2 = useState(false),
    isEdited = _useState2[0],
    setIsEdited = _useState2[1];
  var _useState3 = useState({}),
    formattedSelectedFiles = _useState3[0],
    setFormattedSelectedFiles = _useState3[1];
  var _useState4 = useState(hasCurrentPatient ? false : true),
    isSinglePatient = _useState4[0],
    setIsSinglePatient = _useState4[1];
  var _useState5 = useState(""),
    editRowId = _useState5[0],
    setEditRowId = _useState5[1];
  var _useState6 = useState(new File([], "")),
    currentFile = _useState6[0],
    setCurrentFile = _useState6[1];
  var _useState7 = useState(constants.UPLOAD_UI_STATE.BROWSE_FILE),
    uploadUIState = _useState7[0],
    setUploadUIState = _useState7[1];
  var _useState8 = useState(false),
    showLoading = _useState8[0],
    setShowLoading = _useState8[1];
  var _useState9 = useState(null),
    imageSrc = _useState9[0],
    setImageSrc = _useState9[1];
  var _useState0 = useState(""),
    uploadState = _useState0[0],
    setUploadState = _useState0[1];
  var _useState1 = useState(0),
    uploadProgress = _useState1[0],
    setUploadProgress = _useState1[1];
  var _useState10 = useState(false),
    isProcessingImage = _useState10[0],
    setImageProcessing = _useState10[1];
  var _useState11 = useState(false),
    isGuidelineModal = _useState11[0],
    setIsGuidelineModal = _useState11[1];
  var _useState12 = useState(false),
    isGuidelineActive = _useState12[0],
    setIsGuidelineActive = _useState12[1];
  var hasFilesSelected = !isEmpty(selectedFiles);
  var selectFileRef = useRef(null);
  var checkedFilesLength = size(values(selectedFiles).filter(function (file) {
    return file.isSelected;
  }));
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var _useWorkspacePermitte = useWorkspacePermittedData(true, constants.WORKSPACE_USER_ROLES.WORKSPACE_PATIENT_UPLOAD),
    _useWorkspacePermitte2 = _useWorkspacePermitte.data,
    workspaceData = _useWorkspacePermitte2 === void 0 ? [] : _useWorkspacePermitte2,
    isLoading = _useWorkspacePermitte.isLoading;
  var isFileUploadHidden = uploadUIState !== constants.UPLOAD_UI_STATE.BROWSE_FILE;
  var selectedFilesKeys = Object.keys(formattedSelectedFiles);
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var siteOptions = useMemo(function () {
    var getListSource = function getListSource(sources, filterFn) {
      var _sources$filter;
      return sources === null || sources === void 0 || (_sources$filter = sources.filter(filterFn)) === null || _sources$filter === void 0 ? void 0 : _sources$filter.map(function (src) {
        return {
          label: src.name,
          value: src.id,
          id: src.uuid,
          role: src.role,
          has_permission: src.has_permission,
          synced: src.synced
        };
      });
    };
    if (!hasCurrentPatient) {
      var listSource = getListSource(workspaceData, function (src) {
        return !src.data_hidden;
      });
      var defaultWorkspace = listSource.find(function (item) {
        return String(item.value) === String(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
      });
      if (!isEmpty(listSource)) {
        setSelectedSource(defaultWorkspace !== null && defaultWorkspace !== void 0 ? defaultWorkspace : listSource[0]);
      }
      return listSource;
    } else {
      var _listSource = getListSource(workspaceData, function (item) {
        return item.uuid === (currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.source_id);
      });
      if (!isEmpty(_listSource)) {
        setSelectedSource(_listSource[0]);
      }
      return _listSource;
    }
  }, [workspaceData, userInfo, hasCurrentPatient, currentPatient]);
  var closePopup = function closePopup() {
    setSelectedFiles({});
    onClose();
  };
  var singlePatientFileCheck = function singlePatientFileCheck(nextSelectedFiles) {
    var _files = {};
    Object.values(nextSelectedFiles).forEach(function (item) {
      var metaData = item === null || item === void 0 ? void 0 : item.metaData;
      if (!isEmpty(metaData)) {
        var _find$value, _find, _patient$contact, _patient$additional, _patient$additional$p, _patient$additional2, _patient$additional$p2, _patient$additional3, _patient$additional$p3, _patient$additional4, _metaData$PatientID;
        var PatientID = metaData.PatientID,
          PatientName = metaData.PatientName,
          _metaData$PatientAge = metaData.PatientAge,
          PatientAge = _metaData$PatientAge === void 0 ? "" : _metaData$PatientAge,
          PatientGender = metaData.PatientGender,
          _metaData$PatientBirt = metaData.PatientBirthDate,
          PatientBirthDate = _metaData$PatientBirt === void 0 ? "" : _metaData$PatientBirt,
          _metaData$PatientFirs = metaData.PatientFirstName,
          PatientFirstName = _metaData$PatientFirs === void 0 ? "" : _metaData$PatientFirs,
          _metaData$PatientMidd = metaData.PatientMiddleName,
          PatientMiddleName = _metaData$PatientMidd === void 0 ? "" : _metaData$PatientMidd,
          _metaData$PatientLast = metaData.PatientLastName,
          PatientLastName = _metaData$PatientLast === void 0 ? "" : _metaData$PatientLast;
        var resolvedName = patient !== null && patient !== void 0 && patient.name ? patient === null || patient === void 0 ? void 0 : patient.name : PatientName !== null && PatientName !== void 0 ? PatientName : "";
        var dobFromDicom = parseDicomPatientBirthDateToDate(PatientBirthDate);
        var resolvedDob = (patient === null || patient === void 0 ? void 0 : patient.dob) != null && (patient === null || patient === void 0 ? void 0 : patient.dob) !== "" ? patient === null || patient === void 0 ? void 0 : patient.dob : dobFromDicom !== null && dobFromDicom !== void 0 ? dobFromDicom : null;
        var patientInfo = _objectSpread({
          patient_id: patient !== null && patient !== void 0 && patient.patient_id ? patient === null || patient === void 0 ? void 0 : patient.patient_id : PatientID !== null && PatientID !== void 0 ? PatientID : "",
          name: resolvedName,
          age: patient !== null && patient !== void 0 && patient.age ? "".concat(patient === null || patient === void 0 ? void 0 : patient.age) : parseAgeInYearsFromDicomAttribute(PatientAge),
          gender: (patient === null || patient === void 0 ? void 0 : patient.gender) !== "" ? patient === null || patient === void 0 ? void 0 : patient.gender : (_find$value = (_find = find(constants.GENDERS, {
            shortLabel: PatientGender
          })) === null || _find === void 0 ? void 0 : _find.value) !== null && _find$value !== void 0 ? _find$value : "",
          contact: (_patient$contact = patient === null || patient === void 0 ? void 0 : patient.contact) !== null && _patient$contact !== void 0 ? _patient$contact : "",
          dob: resolvedDob
        }, isLC ? {
          additional: _objectSpread(_objectSpread({}, patient === null || patient === void 0 ? void 0 : patient.additional), {}, {
            patient_name: _objectSpread(_objectSpread({}, patient === null || patient === void 0 || (_patient$additional = patient.additional) === null || _patient$additional === void 0 ? void 0 : _patient$additional.patient_name), {}, {
              first: (_patient$additional$p = patient === null || patient === void 0 || (_patient$additional2 = patient.additional) === null || _patient$additional2 === void 0 || (_patient$additional2 = _patient$additional2.patient_name) === null || _patient$additional2 === void 0 ? void 0 : _patient$additional2.first) !== null && _patient$additional$p !== void 0 ? _patient$additional$p : PatientFirstName,
              middle: (_patient$additional$p2 = patient === null || patient === void 0 || (_patient$additional3 = patient.additional) === null || _patient$additional3 === void 0 || (_patient$additional3 = _patient$additional3.patient_name) === null || _patient$additional3 === void 0 ? void 0 : _patient$additional3.middle) !== null && _patient$additional$p2 !== void 0 ? _patient$additional$p2 : PatientMiddleName,
              last: (_patient$additional$p3 = patient === null || patient === void 0 || (_patient$additional4 = patient.additional) === null || _patient$additional4 === void 0 || (_patient$additional4 = _patient$additional4.patient_name) === null || _patient$additional4 === void 0 ? void 0 : _patient$additional4.last) !== null && _patient$additional$p3 !== void 0 ? _patient$additional$p3 : PatientLastName
            })
          })
        } : {});
        var _key = (_metaData$PatientID = metaData === null || metaData === void 0 ? void 0 : metaData.PatientID) !== null && _metaData$PatientID !== void 0 ? _metaData$PatientID : "";
        if (isEmpty(_files[_key])) {
          _files[_key] = item;
        }
        if (size(_files) === 1) {
          setIsSinglePatient(true);
          setPatient(patientInfo);
        } else {
          setIsSinglePatient(false);
        }
      }
    });
  };
  var onDropFiles = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(currentSelectedFiles) {
      var imageDataUrl, nextSelectedFiles;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsGuidelineModal(false);
            setIsGuidelineActive(false);
            if (!(currentSelectedFiles.length === 1 && isNonDicomFile(get(currentSelectedFiles, [0, "type"], "")) && isMobile)) {
              _context.n = 2;
              break;
            }
            setCurrentFile(currentSelectedFiles[0]);
            setUploadUIState(constants.UPLOAD_UI_STATE.CROP_FILE);
            setImageProcessing(true);
            _context.n = 1;
            return readFile(currentSelectedFiles[0]);
          case 1:
            imageDataUrl = _context.v;
            setImageProcessing(false);
            setImageSrc(imageDataUrl);
            _context.n = 3;
            break;
          case 2:
            nextSelectedFiles = toFilesObject(currentSelectedFiles, selectedFiles);
            if (!isEmpty(selectedFiles)) {
              nextSelectedFiles = merge(nextSelectedFiles, selectedFiles);
            }
            setShowLoading(true);
            setTimeout(function () {
              setMetadataForUploadedFiles(nextSelectedFiles);
            }, 800);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onDropFiles(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var getMetaData = function getMetaData(fileObject) {
    return new Promise(function (resolve) {
      try {
        var fileType = get(fileObject, ["file", "type"], "");
        var _isNonDicomFile = isNonDicomFile(fileType);
        if (_isNonDicomFile) {
          var _currentPatient$patie, _getGender$shortLabel, _getGender, _getGender$shortLabel2, _getGender2, _currentPatient$dob, _currentPatient$conta, _patient$contact2;
          var _id = generatePatientId();
          var metaData = {
            PatientID: hasCurrentPatient ? (_currentPatient$patie = currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_id) !== null && _currentPatient$patie !== void 0 ? _currentPatient$patie : _id : isEdited && patient !== null && patient !== void 0 && patient.patient_id ? patient === null || patient === void 0 ? void 0 : patient.patient_id : _id,
            PatientName: hasCurrentPatient ? currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.name.replace(" ", "^") : isEdited && patient !== null && patient !== void 0 && patient.name ? patient === null || patient === void 0 ? void 0 : patient.name.replace(" ", "^") : "Anon_".concat(_id),
            PatientGender: hasCurrentPatient ? (_getGender$shortLabel = (_getGender = getGender(currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.gender)) === null || _getGender === void 0 ? void 0 : _getGender.shortLabel) !== null && _getGender$shortLabel !== void 0 ? _getGender$shortLabel : "" : isEdited && patient !== null && patient !== void 0 && patient.gender ? (_getGender$shortLabel2 = (_getGender2 = getGender(patient === null || patient === void 0 ? void 0 : patient.gender)) === null || _getGender2 === void 0 ? void 0 : _getGender2.shortLabel) !== null && _getGender$shortLabel2 !== void 0 ? _getGender$shortLabel2 : "" : "",
            PatientAge: hasCurrentPatient ? "".concat(currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.age, "Y") : isEdited && patient !== null && patient !== void 0 && patient.age ? "".concat(patient === null || patient === void 0 ? void 0 : patient.age, "Y") : "0Y",
            PatientBirthDate: hasCurrentPatient ? formatJsDateToDicomDateString((_currentPatient$dob = currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.dob) !== null && _currentPatient$dob !== void 0 ? _currentPatient$dob : null) : isEdited && patient !== null && patient !== void 0 && patient.dob ? formatJsDateToDicomDateString(patient.dob) : "",
            Contact: hasCurrentPatient ? (_currentPatient$conta = currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.contact) !== null && _currentPatient$conta !== void 0 ? _currentPatient$conta : "" : isEdited && patient !== null && patient !== void 0 && patient.contact ? (_patient$contact2 = patient === null || patient === void 0 ? void 0 : patient.contact) !== null && _patient$contact2 !== void 0 ? _patient$contact2 : "" : "",
            SeriesInstanceUID: dcmjs.data.DicomMetaDictionary.uid(),
            SOPInstanceUID: dcmjs.data.DicomMetaDictionary.uid()
          };
          return resolve({
            fileKey: fileObject.fileKey,
            fileName: fileObject.fileName,
            metaData: metaData,
            file: fileObject.file
          });
        } else {
          var reader = new FileReader();
          reader.readAsArrayBuffer(fileObject.file);
          reader.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            var dataSet, metaData, arrayBuffer, byteArray, _dataSet$string, _dataSet, _currentPatient$patie2, _dataSet$string2, _dataSet2, _ref5, _currentPatient$addit, _currentPatient$addit2, _currentPatient$addit3, _currentPatient$addit4, _currentPatient$addit5, _currentPatient$addit6, _getGender$shortLabel3, _getGender3, _dataSet$string3, _dataSet3, _dataSet$string4, _dataSet4, _currentPatient$dob2, _dataSet$string5, _dataSet5, _currentPatient$conta2, _dataSet$string6, _dataSet6, _dataSet$string7, _dataSet7, _dataSet$string8, _dataSet8, _dataSet$string9, _dataSet9, _dataSet$string0, _dataSet0, _dataSet$string1, _dataSet1, _dataSet$string10, _dataSet10, _dataSet$string11, _dataSet11, rawPatientName, nameParts, _ref3, _ref4, _ref4$, lastName, _ref4$2, firstName, _ref4$3, middleName, _t;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  dataSet = {};
                  metaData = null;
                  arrayBuffer = reader.result;
                  _context2.p = 1;
                  byteArray = new Uint8Array(arrayBuffer);
                  dataSet = dicomParser.parseDicom(byteArray, {});
                  _context2.n = 3;
                  break;
                case 2:
                  _context2.p = 2;
                  _t = _context2.v;
                  return _context2.a(2, resolve({
                    fileKey: fileObject.fileKey,
                    fileName: fileObject.fileName,
                    metaData: null
                  }));
                case 3:
                  if (!isEmpty(dataSet)) {
                    rawPatientName = (_dataSet$string = (_dataSet = dataSet) === null || _dataSet === void 0 ? void 0 : _dataSet.string(constants.DICOM_METADATA_TAGS.PatientName)) !== null && _dataSet$string !== void 0 ? _dataSet$string : "";
                    nameParts = rawPatientName.split("^");
                    _ref3 = nameParts.length === 1 ? ["", nameParts[0], ""] : nameParts, _ref4 = _slicedToArray(_ref3, 3), _ref4$ = _ref4[0], lastName = _ref4$ === void 0 ? "" : _ref4$, _ref4$2 = _ref4[1], firstName = _ref4$2 === void 0 ? "" : _ref4$2, _ref4$3 = _ref4[2], middleName = _ref4$3 === void 0 ? "" : _ref4$3;
                    metaData = {
                      PatientID: hasCurrentPatient ? (_currentPatient$patie2 = currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_id) !== null && _currentPatient$patie2 !== void 0 ? _currentPatient$patie2 : generatePatientId() : (_dataSet$string2 = (_dataSet2 = dataSet) === null || _dataSet2 === void 0 ? void 0 : _dataSet2.string(constants.DICOM_METADATA_TAGS.PatientID)) !== null && _dataSet$string2 !== void 0 ? _dataSet$string2 : generatePatientId(),
                      PatientName: hasCurrentPatient ? currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.name.replace(" ", "^") : rawPatientName,
                      PatientFirstName: hasCurrentPatient ? (_ref5 = (_currentPatient$addit = currentPatient === null || currentPatient === void 0 || (_currentPatient$addit2 = currentPatient.additional) === null || _currentPatient$addit2 === void 0 || (_currentPatient$addit2 = _currentPatient$addit2.patient_name) === null || _currentPatient$addit2 === void 0 ? void 0 : _currentPatient$addit2.first) !== null && _currentPatient$addit !== void 0 ? _currentPatient$addit : currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.name) !== null && _ref5 !== void 0 ? _ref5 : "" : firstName,
                      PatientMiddleName: hasCurrentPatient ? (_currentPatient$addit3 = currentPatient === null || currentPatient === void 0 || (_currentPatient$addit4 = currentPatient.additional) === null || _currentPatient$addit4 === void 0 || (_currentPatient$addit4 = _currentPatient$addit4.patient_name) === null || _currentPatient$addit4 === void 0 ? void 0 : _currentPatient$addit4.middle) !== null && _currentPatient$addit3 !== void 0 ? _currentPatient$addit3 : "" : middleName,
                      PatientLastName: hasCurrentPatient ? (_currentPatient$addit5 = currentPatient === null || currentPatient === void 0 || (_currentPatient$addit6 = currentPatient.additional) === null || _currentPatient$addit6 === void 0 || (_currentPatient$addit6 = _currentPatient$addit6.patient_name) === null || _currentPatient$addit6 === void 0 ? void 0 : _currentPatient$addit6.last) !== null && _currentPatient$addit5 !== void 0 ? _currentPatient$addit5 : "" : lastName,
                      PatientGender: hasCurrentPatient ? (_getGender$shortLabel3 = (_getGender3 = getGender(currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.gender)) === null || _getGender3 === void 0 ? void 0 : _getGender3.shortLabel) !== null && _getGender$shortLabel3 !== void 0 ? _getGender$shortLabel3 : "" : (_dataSet$string3 = (_dataSet3 = dataSet) === null || _dataSet3 === void 0 ? void 0 : _dataSet3.string(constants.DICOM_METADATA_TAGS.PatientGender)) !== null && _dataSet$string3 !== void 0 ? _dataSet$string3 : "",
                      PatientAge: hasCurrentPatient ? "".concat(currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.age, "Y") : (_dataSet$string4 = (_dataSet4 = dataSet) === null || _dataSet4 === void 0 ? void 0 : _dataSet4.string(constants.DICOM_METADATA_TAGS.PatientAge)) !== null && _dataSet$string4 !== void 0 ? _dataSet$string4 : "0Y",
                      PatientBirthDate: hasCurrentPatient ? formatJsDateToDicomDateString((_currentPatient$dob2 = currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.dob) !== null && _currentPatient$dob2 !== void 0 ? _currentPatient$dob2 : null) : (_dataSet$string5 = (_dataSet5 = dataSet) === null || _dataSet5 === void 0 ? void 0 : _dataSet5.string(constants.DICOM_METADATA_TAGS.PatientBirthDate)) !== null && _dataSet$string5 !== void 0 ? _dataSet$string5 : "",
                      Contact: hasCurrentPatient ? (_currentPatient$conta2 = currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.contact) !== null && _currentPatient$conta2 !== void 0 ? _currentPatient$conta2 : "" : "",
                      SOPInstanceUID: (_dataSet$string6 = (_dataSet6 = dataSet) === null || _dataSet6 === void 0 ? void 0 : _dataSet6.string(constants.DICOM_METADATA_TAGS.SOPInstanceUID)) !== null && _dataSet$string6 !== void 0 ? _dataSet$string6 : "",
                      SOPClassUID: (_dataSet$string7 = (_dataSet7 = dataSet) === null || _dataSet7 === void 0 ? void 0 : _dataSet7.string(constants.DICOM_METADATA_TAGS.SOPClassUID)) !== null && _dataSet$string7 !== void 0 ? _dataSet$string7 : "",
                      SeriesInstanceUID: (_dataSet$string8 = (_dataSet8 = dataSet) === null || _dataSet8 === void 0 ? void 0 : _dataSet8.string(constants.DICOM_METADATA_TAGS.SeriesInstanceUID)) !== null && _dataSet$string8 !== void 0 ? _dataSet$string8 : "",
                      SeriesDescription: (_dataSet$string9 = (_dataSet9 = dataSet) === null || _dataSet9 === void 0 ? void 0 : _dataSet9.string(constants.DICOM_METADATA_TAGS.SeriesDescription)) !== null && _dataSet$string9 !== void 0 ? _dataSet$string9 : "-",
                      StudyInstanceUID: (_dataSet$string0 = (_dataSet0 = dataSet) === null || _dataSet0 === void 0 ? void 0 : _dataSet0.string(constants.DICOM_METADATA_TAGS.StudyInstanceUID)) !== null && _dataSet$string0 !== void 0 ? _dataSet$string0 : "",
                      StudyDescription: (_dataSet$string1 = (_dataSet1 = dataSet) === null || _dataSet1 === void 0 ? void 0 : _dataSet1.string(constants.DICOM_METADATA_TAGS.StudyDescription)) !== null && _dataSet$string1 !== void 0 ? _dataSet$string1 : "-",
                      StudyDate: (_dataSet$string10 = (_dataSet10 = dataSet) === null || _dataSet10 === void 0 ? void 0 : _dataSet10.string(constants.DICOM_METADATA_TAGS.StudyDate)) !== null && _dataSet$string10 !== void 0 ? _dataSet$string10 : "",
                      Modality: (_dataSet$string11 = (_dataSet11 = dataSet) === null || _dataSet11 === void 0 ? void 0 : _dataSet11.string(constants.DICOM_METADATA_TAGS.Modality)) !== null && _dataSet$string11 !== void 0 ? _dataSet$string11 : ""
                    };
                  }
                  return _context2.a(2, resolve({
                    fileKey: fileObject.fileKey,
                    fileName: fileObject.fileName,
                    metaData: metaData,
                    anonymize_dicom_metadata: hasCurrentPatient,
                    file: hasCurrentPatient && !_isNonDicomFile ? convertBufferToFile(arrayBuffer, fileObject.fileName) : null
                  }));
              }
            }, _callee2, null, [[1, 2]]);
          }));
          reader.onerror = function () {
            return resolve({
              fileKey: fileObject.fileKey,
              fileName: fileObject.fileName,
              metaData: null
            });
          };
        }
      } catch (err) {
        return resolve({
          fileKey: fileObject.fileKey,
          fileName: fileObject.fileName,
          metaData: null
        });
      }
    });
  };
  var setMetadataForUploadedFiles = function setMetadataForUploadedFiles(uploadedFiles) {
    // Filter files that haven't been processed yet
    var unprocessedFiles = values(uploadedFiles).filter(function (file) {
      return !file.isProcessed;
    });
    if (unprocessedFiles.length === 0) {
      // No unprocessed files, return early
      return;
    }
    var filesArray = unprocessedFiles.map(function (file) {
      return getMetaData(file);
    });
    var getFileHash = function getFileHash(resp) {
      var metaHash = "";
      if (resp.metaData) {
        metaHash = join(values(resp.metaData), "");
      }
      return resp.fileName + metaHash;
    };
    Promise.all(filesArray).then(function (response) {
      // Create hash for duplicate browsed file lookup
      var hashMap = response.map(function (resp) {
        return getFileHash(resp);
      });
      var isDuplicateBrowsedFile = function isDuplicateBrowsedFile(resp, index) {
        if (index === 0) return false; // First file is always not a duplicate
        return hashMap.slice(0, index).includes(getFileHash(resp));
      };
      var nextSelectedFiles = cloneDeep(uploadedFiles);
      response.forEach(function (resp, index) {
        var _resp$file, _resp$metaData, _resp$anonymize_dicom;
        var inValidFilters = constants.REQUIRED_DICOM_METADATA.filter(function (field) {
          return isEmpty(get(resp, ["metaData", field], ""));
        });
        var isValid = isEmpty(inValidFilters) || isNonDicomFile(resp === null || resp === void 0 || (_resp$file = resp.file) === null || _resp$file === void 0 ? void 0 : _resp$file.type);
        var fileMetaData = {
          isValidated: true,
          inValidMessage: "",
          metaData: (_resp$metaData = resp.metaData) !== null && _resp$metaData !== void 0 ? _resp$metaData : {},
          anonymize_dicom_metadata: (_resp$anonymize_dicom = resp === null || resp === void 0 ? void 0 : resp.anonymize_dicom_metadata) !== null && _resp$anonymize_dicom !== void 0 ? _resp$anonymize_dicom : false,
          isProcessed: true // Mark the file as processed
        };
        var isDuplicate = isDuplicateBrowsedFile(resp, index);
        if (resp.file) {
          nextSelectedFiles[resp.fileKey].file = resp.file;
        }
        if (isDuplicate) {
          fileMetaData.isSelected = false;
          fileMetaData.isValidated = false;
          fileMetaData.inValidMessage = "Duplicate file";
        } else if (resp.metaData && isValid) {
          // Checks if all metaData values are non-null
        } else if (!isDuplicate && !isValid) {
          fileMetaData.isSelected = false;
          fileMetaData.isValidated = false;
          fileMetaData.inValidMessage = isEmpty(resp.metaData) ? t("invalid_scan") : "".concat(t("missing_metadata"), ": ").concat(inValidFilters.join(", "));
        } else {
          fileMetaData.isSelected = false;
          fileMetaData.isValidated = false;
          fileMetaData.inValidMessage = "Invalid Format";
        }
        updateFileState(resp.fileKey, fileMetaData, nextSelectedFiles);
      });

      // Check if the uploaded scans belong to the same patient
      singlePatientFileCheck(nextSelectedFiles);
      setSelectedFiles(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), nextSelectedFiles);
      });
    })["catch"](function (error) {
      console.error("Error reading the object:", error);
    })["finally"](function () {
      setShowLoading(false);
    });
  };
  var onAddFile = function onAddFile() {
    if (selectFileRef && selectFileRef.current) {
      selectFileRef.current.click();
    }
  };
  useEffect(function () {
    if (!isEmpty(selectedFiles)) {
      var newFiles = {};
      var keys = Object.keys(selectedFiles);
      keys.forEach(function (key) {
        var seriesInstanceUID = get(selectedFiles, [key, "metaData", "SeriesInstanceUID"], "");
        var sopInstanceUID = get(selectedFiles, [key, "metaData", "SOPInstanceUID"], "");
        var isDuplicateFile = some(flatMap(values(newFiles[seriesInstanceUID] || [])), function (nestedObj) {
          var _nestedObj$metaData;
          return (nestedObj === null || nestedObj === void 0 || (_nestedObj$metaData = nestedObj.metaData) === null || _nestedObj$metaData === void 0 ? void 0 : _nestedObj$metaData.SOPInstanceUID) === sopInstanceUID;
        });
        if (isEmpty(newFiles[seriesInstanceUID])) {
          newFiles[seriesInstanceUID] = [get(selectedFiles, [key], {})];
        } else if (!isDuplicateFile) {
          newFiles[seriesInstanceUID].push(get(selectedFiles, [key], {}));
        }
      });
      setFormattedSelectedFiles(newFiles);
    }
  }, [selectedFiles]);
  var onUpload = function onUpload() {
    trackEvent(hasCurrentPatient ? MIXPANEL_EVENTS.ADD_SCANS_FOR_PATIENT : MIXPANEL_EVENTS.SUBMIT_ADD_PATIENT);
    var cloneSelectedFiles = values(cloneDeep(selectedFiles)).filter(function (fileObj) {
      return fileObj.isSelected;
    }).reduce(function (acc, file) {
      acc[file.fileKey] = file;
      return acc;
    }, {});
    closePopup();
    onConfirmUpload(cloneSelectedFiles);
  };
  var onConfirmedUpload = function onConfirmedUpload(imageFile) {
    var nextSelectedFiles = toFilesObject([imageFile], selectedFiles);
    if (!isEmpty(selectedFiles)) {
      nextSelectedFiles = merge(nextSelectedFiles, selectedFiles);
    }
    setShowLoading(true);
    setTimeout(function () {
      setMetadataForUploadedFiles(nextSelectedFiles);
    }, 800);
    onMainUploadScreen();
  };
  var onMainUploadScreen = function onMainUploadScreen() {
    setUploadUIState(constants.UPLOAD_UI_STATE.BROWSE_FILE);
    setUploadProgress(0);
    setUploadState(INITIAL_UPLOAD_STATE);
    setIsGuidelineModal(false);
  };
  var isUploadComplete = useMemo(function () {
    return !!uploadProgress && [constants.UPLOAD_STATE.COMPLETE, constants.UPLOAD_STATE.FAILED, constants.UPLOAD_STATE.FAILED_LOW_RES].indexOf(uploadState) !== -1;
  }, [uploadState, uploadProgress]);
  return /*#__PURE__*/React.createElement(ParentModal, {
    closePopup: closePopup,
    hasCurrentPatient: hasCurrentPatient,
    isLoading: isLoading
  }, !isProcessingImage && uploadUIState !== constants.UPLOAD_UI_STATE.CROP_FILE && !isGuidelineModal && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: classNames("text-xl mx-4 text-whit sm:hidden", {
      hidden: hasCurrentPatient
    })
  }, t("add_patient_scans")), /*#__PURE__*/React.createElement(SelectWorkspace, {
    siteOptions: siteOptions,
    className: classNames("my-4 px-4"),
    setSelectedSource: setSelectedSource,
    selectedSource: selectedSource,
    disabled: hasCurrentPatient
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col sm:overflow-visible sm:pb-6 flex-1 sm:grid sm:grid-cols-2 sm:gap-6 mx-4 ", {
      "gap-6": isSinglePatient && isEmpty(formattedSelectedFiles),
      "sm:py-6": isSinglePatient,
      "!grid-cols-1 sm:!grid-cols-1": disableScanUpload
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("sm:col-span-1", {
      "sm:!col-span-2 !h-full": hasCurrentPatient || hasFilesSelected && !isSinglePatient,
      hidden: disableScanUpload && !hasCurrentPatient
    })
  }, /*#__PURE__*/React.createElement(ScanUpload, {
    onDropFiles: onDropFiles,
    hasFilesSelected: hasFilesSelected,
    isSinglePatient: isSinglePatient,
    hasCurrentPatient: hasCurrentPatient,
    showLoading: showLoading,
    formattedSelectedFiles: formattedSelectedFiles,
    onAddFile: onAddFile,
    setIsGuidelineModal: setIsGuidelineModal,
    currentPatient: currentPatient,
    selectedFilesKeys: selectedFilesKeys,
    selectFileRef: selectFileRef,
    selectedFiles: selectedFiles,
    setSelectedFiles: setSelectedFiles,
    editRowId: editRowId,
    setEditRowId: setEditRowId
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames(" flex-1 flex flex-col space-y-6 sm:space-y-0 sm:col-span-1 overflow-hidden sm:overflow-visible", {
      "!hidden ": hasCurrentPatient || hasFilesSelected && !isSinglePatient
    })
  }, /*#__PURE__*/React.createElement(RegistrationForm, {
    selectedSource: selectedSource,
    setSelectedFiles: setSelectedFiles,
    patient: patient,
    setPatient: setPatient,
    isSinglePatient: isSinglePatient,
    onUpload: onUpload,
    selectedFiles: selectedFiles,
    closePopup: closePopup,
    onConfirmUpload: onConfirmUpload,
    selectedFilesKeys: selectedFilesKeys,
    formattedSelectedFiles: formattedSelectedFiles,
    hasCurrentPatient: hasCurrentPatient,
    hasFilesSelected: hasFilesSelected,
    currentPatient: currentPatient,
    isUploadInProgress: isUploadInProgress,
    showLoading: showLoading,
    onAddFile: onAddFile,
    setIsEdited: setIsEdited,
    isEdited: isEdited,
    checkedFilesLength: checkedFilesLength,
    setIsGuidelineModal: setIsGuidelineModal
  })))), isProcessingImage && /*#__PURE__*/React.createElement("div", {
    className: "h-60 flex justify-center items-center"
  }, /*#__PURE__*/React.createElement(Loader, {
    label: t("cropping_message")
  })), uploadUIState === constants.UPLOAD_UI_STATE.CROP_FILE && !isUploadComplete && !isProcessingImage && /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden flex-1 flex flex-col"
  }, /*#__PURE__*/React.createElement(CropImage, {
    imageSrc: imageSrc,
    isUploadComplete: isUploadComplete,
    onMainUploadScreen: onMainUploadScreen,
    onConfirmedUpload: onConfirmedUpload,
    currentFile: currentFile,
    hasCurrentPatient: hasCurrentPatient
  })), /*#__PURE__*/React.createElement(Footer, {
    isFileUploadHidden: isFileUploadHidden || isSinglePatient && !hasCurrentPatient,
    hasFilesSelected: hasFilesSelected,
    disableUpload: checkedFilesLength <= 0 || (editRowId === null || editRowId === void 0 ? void 0 : editRowId.length) > 0,
    isLoading: showLoading,
    onAddFile: onAddFile,
    onUpload: onUpload
  }), isGuidelineModal && uploadUIState !== constants.UPLOAD_UI_STATE.CROP_FILE && /*#__PURE__*/React.createElement(FileDropzone, {
    className: "invisible h-0",
    onDropFiles: onDropFiles,
    isDropzoneDisabled: false
  }, function (_ref6) {
    var open = _ref6.open;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      ref: selectFileRef,
      onClick: open,
      type: "button"
    }, "fileInput"));
  }), /*#__PURE__*/React.createElement(GuidelineModal, {
    onClose: function onClose() {
      setIsGuidelineModal(false);
    },
    isVisible: isGuidelineModal && uploadUIState !== constants.UPLOAD_UI_STATE.CROP_FILE,
    onAddFile: onAddFile,
    isGuidelineActive: isGuidelineActive,
    setIsGuidelineActive: setIsGuidelineActive
  }));
};
export default UploadModal;